
export enum ConversationActionItemStatCd {
	COMPLETED = 'Completed',
	OPEN = 'Open',
	REASSIGNED = 'Reassigned',
	REVIEWED = 'Reviewed'}

